// @flow
import * as React from 'react';
import Grid from 'styled-components-grid';

import {
  ABOUT_US,
  HOW_IT_WORKS,
  FINDER_FACILITY,
  FINDER_DOCTOR,
  PROFILE_LOGIN,
  FAQS,
  COMPANY_IMPRESSUM,
  COMPANY_DATA_PROTECTION,
  COMPANY_DATA_PROCESSING,
  COMPANY_FOR_HOSPITALS,
  COMPANY_TERMS,
  BLOG,
  COMPANY_REFUND
} from '@routes';

import { Link, withTranslation } from '@i18n';

import {
  StyledFooterLinks,
  StyledListTitle,
  StyledList,
  StyledListItem,
  StyledListLink
} from './styles';

const FooterLinks = ({ t, curefyDomain }) => (
  <StyledFooterLinks>
    <Grid>
      <Grid.Unit size={{ mobile: 1, desktop: 1 / 2 }}>
        <Grid>
          <Grid.Unit size={{ mobile: 1 / 2, desktop: 1 / 2 }}>
            <StyledList>
              <Link href="/" passHref>
                <StyledListTitle curefyDomain={curefyDomain}>{t('Home')}</StyledListTitle>
              </Link>

              <StyledListItem>
                <Link href={curefyDomain ? 'https://curefy.ai/en' : '/'} passHref>
                  <StyledListLink curefyDomain={curefyDomain}>{t('HomePage')}</StyledListLink>
                </Link>
              </StyledListItem>

              <StyledListItem>
                <Link href={curefyDomain ? 'https://curefy.ai/en/faqs/categories/second-opinion' : FAQS} passHref>
                  <StyledListLink curefyDomain={curefyDomain}>{t('FAQs')}</StyledListLink>
                </Link>
              </StyledListItem>

              <StyledListItem>
                <Link href={PROFILE_LOGIN} passHref>
                  <StyledListLink curefyDomain={curefyDomain}>{t('Login')}</StyledListLink>
                </Link>
              </StyledListItem>
            </StyledList>
          </Grid.Unit>

          <Grid.Unit size={{ mobile: 1 / 2, desktop: 1 / 2 }}>
            <StyledList>
              <Link href={ABOUT_US} passHref>
                <StyledListTitle curefyDomain={curefyDomain}>{t('About')}</StyledListTitle>
              </Link>

              <StyledListItem>
                <Link href={ABOUT_US} passHref>
                  <StyledListLink curefyDomain={curefyDomain}>{t('AboutUs')}</StyledListLink>
                </Link>
              </StyledListItem>

              {curefyDomain
                ? <></>
                : (
                  <StyledListItem>
                    <Link href={COMPANY_FOR_HOSPITALS} passHref>
                      <StyledListLink curefyDomain={curefyDomain}>{t('ForHospitals')}</StyledListLink>
                    </Link>
                  </StyledListItem>
                )}
            </StyledList>
          </Grid.Unit>
        </Grid>
      </Grid.Unit>

      <Grid.Unit size={{ desktop: 1 / 2, mobile: 1 }}>
        <Grid>
          <Grid.Unit size={{ desktop: 1 / 2, mobile: 1 / 2 }}>
            <StyledList>
              <StyledListTitle noPointer curefyDomain={curefyDomain}>{t('Explore')}</StyledListTitle>

              {curefyDomain
                ? <></>
                : (
                  <StyledListItem>
                    <Link href={HOW_IT_WORKS} passHref>
                      <StyledListLink curefyDomain={curefyDomain}>{t('HowItWorks')}</StyledListLink>
                    </Link>
                  </StyledListItem>
                )}

              {curefyDomain
                ? <></>
                : (
                  <StyledListItem>
                    <Link href={FINDER_FACILITY} passHref>
                      <StyledListLink curefyDomain={curefyDomain}>{t('FacilityFinder')}</StyledListLink>
                    </Link>
                  </StyledListItem>
                )}
              <StyledListItem>
                <Link href={FINDER_DOCTOR} passHref>
                  <StyledListLink curefyDomain={curefyDomain}>{t('DoctorFinder')}</StyledListLink>
                </Link>
              </StyledListItem>
              <StyledListItem>
                <Link href={curefyDomain ? 'https://curefy.ai/gp/blogs/' : BLOG} passHref>
                  <StyledListLink curefyDomain={curefyDomain}>{t('BlogFinder')}</StyledListLink>
                </Link>
              </StyledListItem>
              {curefyDomain
                ? (
                  <StyledListItem>
                    <Link href="https://curefy.ai/gp/" passHref>
                      <StyledListLink curefyDomain={curefyDomain}>{t('HealthGPT')}</StyledListLink>
                    </Link>
                  </StyledListItem>
                )
                : <></> }
            </StyledList>
          </Grid.Unit>

          <Grid.Unit size={{ mobile: 1 / 2, desktop: 1 / 2 }}>
            <StyledList>
              <StyledListTitle noPointer curefyDomain={curefyDomain}>Others</StyledListTitle>

              <StyledListItem>
                <Link href={COMPANY_TERMS} passHref>
                  <StyledListLink curefyDomain={curefyDomain}>{t('TermsAndConditions')}</StyledListLink>
                </Link>
              </StyledListItem>

              <StyledListItem>
                <Link href={COMPANY_DATA_PROTECTION} passHref>
                  <StyledListLink curefyDomain={curefyDomain}>{t('DataProtection')}</StyledListLink>
                </Link>
              </StyledListItem>

              <StyledListItem>
                <Link href={COMPANY_DATA_PROCESSING} passHref>
                  <StyledListLink curefyDomain={curefyDomain}>{t('DataProcessing')}</StyledListLink>
                </Link>
              </StyledListItem>

              <StyledListItem>
                <Link href={COMPANY_REFUND} passHref>
                  <StyledListLink curefyDomain={curefyDomain}>{t('RefundPolicy')}</StyledListLink>
                </Link>
              </StyledListItem>

              <StyledListItem>
                <Link href={COMPANY_IMPRESSUM} passHref>
                  <StyledListLink curefyDomain={curefyDomain}>{t('Imprint')}</StyledListLink>
                </Link>
              </StyledListItem>

              <StyledListItem>
                <Link href="https://yapitahealth.com/en/sitemap.html" passHref>
                  <StyledListLink curefyDomain={curefyDomain}>{t('Sitemap')}</StyledListLink>
                </Link>
              </StyledListItem>
            </StyledList>
          </Grid.Unit>
        </Grid>
      </Grid.Unit>
    </Grid>
  </StyledFooterLinks>
);

export default withTranslation('Footer')(FooterLinks);
